// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3D_I-","header":"ClearentDisclaimer_header__2LI_X","inner":"ClearentDisclaimer_inner__2LqoW"};